import { View } from "ui/atoms/view";
import { Text } from "react-native";
import { FormControlledInputTextArea } from "ui/molecules/form/FormControlledInputTextArea";
import { validateFileExtensions } from "ui/utils/Validators";
import UploadDocumentArea from "ui/organisms/UploadDocumentArea";
import { generalAllowedExtensions } from "../../../constants/allowedExtensionsConstants";
import { Controller } from "react-hook-form";
import { useUpdateBodyMapEntry } from "../hooks/useUpdateBodyMapEntry";
import { Button, ButtonText } from "ui/gluestack/button";

interface Props {
  residentId: number;
  entryId: number;
  onClose: () => void;
}

export default function UpdateBodyMapEntryForm({
  residentId,
  entryId,
  onClose,
}: Props) {
  const { control, submit, isSubmitting, getValues } = useUpdateBodyMapEntry({
    residentId,
    entryId,
    onSuccess: onClose,
  });

  return (
    <View className="gap-3">
      <Text className="text-base font-normal text-typography-900">
        New update
      </Text>
      <FormControlledInputTextArea
        id="comment"
        name="comment"
        control={control}
        placeholder="Enter relevant information about the areas marked"
        className="text-gray-500"
      />
      <Controller
        control={control}
        name="image"
        render={({ field: { value, onChange }, fieldState: { error } }) => (
          <UploadDocumentArea
            value={value}
            onChange={onChange}
            allowedExtensions={generalAllowedExtensions}
            errorMessage={error}
            singleFile
          />
        )}
        rules={{
          validate: {
            validExtensions: validateFileExtensions(generalAllowedExtensions),

            commentOrImage: (value) => {
              const { comment } = getValues();
              if ((!value || value.length === 0) && !comment) {
                return "Please provide either a comment or an image.";
              }
              return true;
            },
          },
        }}
      />
      <View className="col-span-full">
        <View className="flex justify-end gap-4 sm:flex-row sm:gap-x-4 mt-10">
          <Button
            action="primary"
            size="sm"
            variant="outline"
            onPress={onClose}
          >
            <ButtonText>Cancel</ButtonText>
          </Button>
          <Button
            action="primary"
            size="sm"
            onPress={submit}
            disabled={isSubmitting}
          >
            <ButtonText className="text-white">Log Finding</ButtonText>
          </Button>
        </View>
      </View>
    </View>
  );
}
